import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';


@Injectable({ providedIn: 'root' })
export class PaymentLinkService {
  constructor(private crud: CrudService) {}

  saveRideForPayment(rideData: any) {
    return this.crud.postData('pagamento-link/salvar-corrida', '', rideData);
  }

  getSavedRides() {
    return this.crud.getData('pagamento-link/corridas-salvas');
  }

  generatePaymentLink(corridaIds: string[]) {
    return this.crud.postData('pagamento-link/gerar-link', '', { corridaIds });
  }

  generatePaymentLinkIndividual(corridaId: string, valorCorrida?: number) {
    const body: any = { corridaId };
    if (valorCorrida != null) body.valorCorrida = valorCorrida;
    return this.crud.postData('pagamento-link/gerar-link-individual', '', body);
  }

  getHistory() {
    return this.crud.getData('pagamento-link/historico');
  }

  deleteSavedRide(corridaId: string) {
    return this.crud.deleteData('pagamento-link/excluir-corrida-salva', corridaId);
  }

  getFeeConfig() {
    return this.crud.getData('pagamento-link/fee-config');
  }
}
